import { IconButton } from '@material-ui/core';
import PrintIcon from '@material-ui/icons/Print';
import React, { useCallback, useEffect, useState } from 'react';
import { TbDymo } from '../../../../tools/TbDymo/TbDymo';
import styledComponentsTheme from '../../../common/react/theme/styledComponentsTheme';

export const PrintButton = ({
    dymoConnected,
    tbDymo,
    hardwareVersion,
    boxNumber,
    serial,
    ...props
}: {
    dymoConnected: boolean;
    serial: string;
    tbDymo: TbDymo;
    hardwareVersion: string;
    boxNumber: number | string;
}) => {
    const [printed, setPrinted] = useState(false);

    useEffect(() => {
        const printed = localStorage.getItem(`voiceAssistantEnrollment:${serial}:printed`);
        setPrinted(printed === 'true');
    }, []);

    const dymoPrint = useCallback(async () => {
        await tbDymo.printSerialV2(serial);
        await tbDymo.printSerialV2(serial);
        await tbDymo.printSerialV2(serial);
        await tbDymo.printSerialV2(serial);
        await tbDymo.printBox(boxNumber);
        localStorage.setItem(`voiceAssistantEnrollment:${serial}:printed`, 'true');
        setPrinted(true);
    }, [boxNumber, serial, hardwareVersion]);
    return (
        <IconButton
            {...props}
            disabled={!dymoConnected}
            style={{ opacity: dymoConnected ? 1 : 0.2, color: printed ? styledComponentsTheme.colors.darkgreen : '' }}
            onClick={dymoConnected ? dymoPrint : null}
        >
            <PrintIcon />
        </IconButton>
    );
};
